import { createContext, useContext } from "react";

type AccordionIndexContextType = {
  getNextIndex: () => number;
} | null;

export const AccordionIndexContext =
  createContext<AccordionIndexContextType>(null);

export function useAccordionIndex(): number {
  const context = useContext(AccordionIndexContext);
  if (!context) {
    return 0;
  }
  return context.getNextIndex();
}
